<template>
  <select-form
    :name="fieldName"
    :validator="validator"
    :dispatcher="dispatcher"
    :selectable-items="cities"
    :default-item="defaultItem"
  />
</template>

<script setup>
import { nextTick, watch } from 'vue';
import { useStore } from 'vuex';
import SelectForm from '@component_path/pages/pc/agent_selection/secret/components/form_element/Select';
import {
  useAddressField,
  useAddressStore
} from '@component_path/agent_selection_wish_module/custom_hook/Address';
import { useCityIdStore } from '@component_path/inquiry_form_common_module/custom_hook/CityId';
import { usePrefectureIdStore } from '@component_path/inquiry_form_common_module/custom_hook/PrefectureId';

const store = useStore();

const props = defineProps({
  required: {
    type: Boolean,
    required: false,
    default: false
  },
  defaultItem: {
    type: Object,
    required: false,
    default: {
      value: null,
      label: '市区町村'
    }
  }
});

const { fieldName, validator } = useAddressField(props.required);
const { dispatcher } = useAddressStore();
const { cities } = useCityIdStore();
const { prefectureId } = usePrefectureIdStore();

watch(prefectureId, () => {
  nextTick(() => {
    store.dispatch(dispatcher.value, null);
  });
});
</script>
